import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { AdminProvider } from "./contexts/AdminContext";
import LiveHomePage from "./pages/LiveHomePage";
import BroadcastPage from "./pages/BroadcastPage";
import ViewerPage from "./pages/ViewerPage";

// Admin pages
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminHomePage from "./pages/admin/AdminHomePage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminUsersPage from "./pages/admin/AdminUsersPage";
import AdminStreamsPage from "./pages/admin/AdminStreamsPage";
import AdminEventsPage from "./pages/admin/AdminEventsPage";
import AdminAnalyticsPage from "./pages/admin/AdminAnalyticsPage";
import AdminTeamPage from "./pages/admin/AdminTeamPage";
import AdminSettingsPage from "./pages/admin/AdminSettingsPage";

function App() {
  return (
    <AuthProvider>
      <AdminProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Main app routes */}
              <Route path="/" element={<Navigate to="/live" replace />} />
              <Route path="/live" element={<LiveHomePage />} />
              <Route path="/live/broadcast/:streamId" element={<BroadcastPage />} />
              <Route path="/live/watch/:streamId" element={<ViewerPage />} />
              
              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="/admin/home" replace />} />
                <Route path="home" element={<AdminHomePage />} />
                <Route path="dashboard" element={<AdminDashboardPage />} />
                <Route path="users" element={<AdminUsersPage />} />
                <Route path="streams" element={<AdminStreamsPage />} />
                <Route path="events" element={<AdminEventsPage />} />
                <Route path="analytics" element={<AdminAnalyticsPage />} />
                <Route path="team" element={<AdminTeamPage />} />
                <Route path="settings" element={<AdminSettingsPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </AdminProvider>
    </AuthProvider>
  );
}

export default App;